module.exports = {"title":{"ja":"バーチャルラン参加フロー","en":"Get Started"},"important":{"ja":"重要","en":"Important"},"appSync":{"ja":"連携確認","en":"Sync Status"},"flows":[{"download":{"ja":"アプリの<br>ダウンロード","en":"Download<br>the app"}},{"entry":{"ja":"大会・イベント<br>にエントリー","en":"Enter to<br>an event"}},{"coop":{"ja":"アプリとランキングサイトの連携設定","en":"Sync your app to the event"}},{"save":{"ja":"イベント参加・ラン（アクティビティ）の保存","en":"Start your activity and save"}},{"ranking":{"ja":"ランキング発表","en":"Check your ranking"}}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/constants/top/flow-participation.json
// module id = 0XGq
// module chunks = 1